//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	// import rankList from '@/components/donateTogether/rankList'
	import headerBackTitleShare from '@/components/header/headerBackTitleShare'
	export default {
		components: {
			// rankList,
			headerBackTitleShare
		},
		data() {
			return {
				threeList: [],
				companyList: [],
				shareInfo:{},   //app分享信息
				sortIndex: 1,
				listTotal: '',
				acr001: this.$route.params.acr001,
				imgUrl:require('../assets/images/rankShare.png')
			}
		},
		methods: {
			staffRankLink(orgName,epId) {
	   		this.$router.push('/dTRankStaff/'+orgName+'/'+this.acr001+'_'+epId+'/'+epId+'/'+this.acr001)
	   	},
			refresh (done) {
				setTimeout(() =>{
		 			this.sortIndex = 1
			   	this.threeList = []
			   	this.companyList = []
			 		this.getRankCompany(done);
		 			done()
		 		}, 1000)

		  },
		 	infinite (done) {
		 		setTimeout(() => {
		 			if(this.companyList.length < this.listTotal){
				 		this.sortIndex++
				 		this.getRankCompany(done);
		 			}else {
			 			done(true)
		 			}
		 		}, 1000)
		 	},
			getRankCompany(done) {
				let data={
	        crowdfundingId: this.acr001,
	        pageIndex: this.sortIndex,
	        pageSize: 10
	      }
        this.$https.post(this.BASE_URL+"grd/groupDonation/listOfGroupDonationByCFID",
          data,
        )
        .then(res => {
        	if(res.data.code == "GRDI0000") {
        		this.listTotal = res.data.data.total
	          // let copyList = [...this.companyList]
	          if(this.sortIndex == 1) {
	          	this.threeList = [...res.data.data.data.slice(0,3)]
	          	this.companyList = [...res.data.data.data.slice(3)]
	          }else {
	          	this.companyList = [...this.companyList,...res.data.data.data];
	          }
	          this.wechatshareneedkey()
	          // if(done){
	         	// 	done(true)
	         	// }
        	}
        	if(done){
         		done(true)
         	}
        })
        .catch(function(err) {
        	console.log(err);
        })
			},
			wechatshareneedkey  () {
	   		if(this.isWeixinCient()){
	   			let lineLink=window.location.href.split('#')[0];//要分享页面的地址，即该页面地址
	   			this.shareInfo = {
		        title : '社会帮扶，让爱在阳光下连接~ ',
		        desc: '参与一起捐，播撒爱心，点燃希望~',
		        link : this.appjump_url+'/pages/index/#/dTRankCompany/'+this.$route.params.acr001+'?isSingle=single',
		        imgUrl: this.appjump_url+'/pages/index/shareIcon/rankShare.png'
			    };
			    this.setWeixinConfig(this.shareInfo);
	   		}else{
	   			let title = '社会帮扶，让爱在阳光下连接~ '
	   			let desc = '参与一起捐，播撒爱心，点燃希望~'
	   			this.shareInfo = '{"picurl":"'+this.appjump_url+'/pages/index/shareIcon/rankShare.png","title":"'+title+'","type":"'+2+'","projectId":"'+this.$route.params.acr001+'","text":"'+desc+'","url":"'+this.appjump_url+'/pages/index/#/dTRankCompany/'+this.$route.params.acr001+'?isSingle=single","ischange":'+'"2"'+'}'
	   			console.log(this.shareInfo)
	   		}
   	},
		},
		created() {
			this.getRankCompany()
		},
		mounted() {
			if(this.$route.query.isSingle == "single") {
				let headback = document.getElementsByClassName('left-arrow')[0]
				let ua = navigator.userAgent.toLowerCase();
				headback.style.display = "none"
			}
		}
	}



// WEBPACK FOOTER //
// ./src/crowd_fund/dTRankCompany.vue